var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"xingyongfengxian-layer"},[_c('caseheader'),_c('div',{staticClass:"xyfx-container"},[_c('div',{staticClass:"xyfx-content"},[_c(_vm.currentStep,{tag:"component",on:{"nextStep":_vm.nextStep}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }